// **** import modules ****
import { vuwer } from "@@assets/scripts/common";
import setForm from "./_vuw.fm";


// **** process ****
const promise = setForm();

vuwer.add("authSection", {
	selector: "#auth_section",
	async onReady($self) {
		const fm = await promise;
		await fm.getReady();
	}
});
